<ng-container [formGroup]="newEditForm">
    <td class="long">
        <app-filterable-list [itemsList]="allGrupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasCaja')"
        [disabled]="disabledCaja" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="long">
        <app-filterable-list [itemsList]="allGrupoEtiquetasPallet" [selectedItem]="newEditForm.get('grupoEtiquetasPallet')"
        [disabled]="disabledPallet" [placeHolder]="false"></app-filterable-list>
    </td>
    <td class="actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" (click)="edit()"></i>
        </ng-container>
    </td>
</ng-container>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary">{{'global.cancelar' | translate}}</button>
            <button>{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>